export default __webpack_public_path__ + "static/media/gcp-logo.f646e439.svg";